export const SERVICE = 'CUPS_SEARCHER'
